import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
    name: "customerEmailFilter"
})
export class SearchPipe implements PipeTransform {
    transform(value: any, args?: any): any {


        if (!args) {
            return value;
        } else {


            // if (args['0'] === '1') {
            //     args['0'] = 'Yes';
            // } else if (args['0'] === '0') {
            //     args['0'] = 'No';
            // } else {
            //     args['0'] = '-';
            // }

            // if (args['1'] === '1') {
            //     args['1'] = 'Yes';
            // } else if (args['1'] === '0') {
            //     args['1'] = 'No';
            // } else {
            //     args['1'] = '-';
            // }

            // if (args['2'] === '1') {
            //     args['2'] = 'Yes';
            // } else if (args['2'] === '0') {
            //     args['2'] = 'No';
            // } else {
            //     args['2'] = '-';
            // }



            // if (args[0] === '-' && args[1] === '-' && args[2] === '-') {
            //     return value;
            // } else {

            //     return value.filter(val => {
            //         let rVal
            //         if (args['0'] !== '-') {
            //             rVal = val.checkbox.includes(args['0']);
            //         } else {
            //             rVal = ''
            //         }
            //         if (args['1'] !== '-') {
            //             rVal += val.supplier.includes(args['1']);
            //         } else {
            //             rVal += ''
            //         }
            //         if (args['2'] !== '-') {
            //             rVal += val.executed_contract_submitted.includes(args['2']);
            //         } else {
            //             rVal += ''
            //         }

            //         // val.supplier.includes(args['1']) &&
            //         // val.executed_contract_submitted.includes(args['2']);
            //         return rVal;
            //     });
            // }




            if (args[0] === '2' && args[1] === '2') {
                return value;
            } else if (args[0] === '1' && args[1] === '1') {
                return value.filter(val => {
                    let rVal =
                        val.checkbox.includes('Yes') &&
                        val.supplier.includes('Yes');
                    return rVal;
                });
            } else if (args[0] === '1' && args[1] === '0') {
                return value.filter(val => {
                    let rVal =
                        val.checkbox.includes('Yes') &&
                        val.supplier.includes('No');
                    return rVal;
                });
            } else if (args[0] === '1' && args[1] === '2') {
                return value.filter(val => {
                    let rVal =
                        val.checkbox.includes('Yes')
                    return rVal;
                });
            } else if (args[0] === '0' && args[1] === '1') {
                return value.filter(val => {
                    let rVal =
                        val.checkbox.includes('No') &&
                        val.supplier.includes('Yes');
                    return rVal;
                });
            } else if (args[0] === '0' && args[1] === '0') {
                return value.filter(val => {
                    let rVal =
                        val.checkbox.includes('No') &&
                        val.supplier.includes('No');
                    return rVal;
                });
            } else if (args[0] === '0' && args[1] === '2') {
                return value.filter(val => {
                    let rVal =
                        val.checkbox.includes('No')
                    return rVal;
                });
            } else if (args[0] === '2' && args[1] === '1') {
                return value.filter(val => {
                    let rVal =
                        val.supplier.includes('Yes')
                    return rVal;
                });
            } else if (args[0] === '2' && args[1] === '0') {
                return value.filter(val => {
                    let rVal =
                        val.supplier.includes('No')
                    return rVal;
                });
            } else {
                alert('other cond')
            }
        }
        // if (args[0] === 'checkboxNo' && args[1] === 'supplierNo') {

        //     return value;
        // }
        // if (args[0] === 'checkbox' && args[1] === 'supplier') {
        //     return value.filter(val => {
        //         let rVal =
        //             val.checkbox.includes('Yes') ||
        //             val.supplier.includes('Yes');
        //         return rVal;
        //     });
        // } else if (args[0] === 'checkbox' && args[1] === 'supplierNo') {
        //     return value.filter(val => {
        //         let rVal =
        //             val.checkbox.includes('Yes');
        //         return rVal;
        //     });
        // } else if (args[0] === 'checkboxNo' && args[1] === 'supplier') {
        //     return value.filter(val => {
        //         let rVal =
        //             val.supplier.includes('Yes');
        //         return rVal;
        //     });
        // } else {
        //     return value;
        // }

        // if (args === 'supplier') {
        //     return value.filter(val => {
        //         let rVal =
        //             val[args].includes('Yes');
        //         return rVal;
        //     });
        // }


    }
}



// WEBPACK FOOTER //
// ./src/app/search.pipe.ts